import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import sanitizeHtml from 'sanitize-html';
import { translate } from 'utils/translation';
import { Button } from '../Button';

const WarningModal = ({
  onClose, onConfirm, onCancel, onAction, text, title, buttonCancel, buttonConfirm, buttonAction, confirmOnly
}) => {
  const handleCancel = useCallback(() => {
    onCancel && onCancel();
    onClose();
  }, [onCancel, onClose]);

  const handleAction = useCallback(() => {
    onAction && onAction();
    onClose();
  }, [onAction, onClose]);

  const handleConfirm = useCallback(() => {
    if (onConfirm) {
      onConfirm();
      return onClose();
    }

    return onClose();
  }, [onConfirm, onClose]);

  return (
    <>
      <DialogTitle className={confirmOnly ? '' : 'warningModal'}>
        {!confirmOnly && <FontAwesomeIcon icon={faExclamationTriangle} />}
        {translate(title)}
      </DialogTitle>

      <DialogContent dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate(text)) }} style={{ maxWidth: '500px' }} />

      <DialogActions>
        {buttonCancel && (
          <Button type="default" variant="text" onClick={handleCancel}>{translate(buttonCancel)}</Button>
        )}
        {buttonAction && (
          <Button type="default" variant="text" onClick={handleAction}>{translate(buttonAction)}</Button>
        )}
        <Button
          data-testid={buttonConfirm}
          id="warningModalConfirm"
          type={confirmOnly ? 'primary' : 'danger'}
          variant="text"
          onClick={handleConfirm}
        >
          {translate(buttonConfirm)}
        </Button>
      </DialogActions>
    </>
  );
};

WarningModal.propTypes = {
  buttonAction: PropTypes.string,
  buttonCancel: PropTypes.string,
  buttonConfirm: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onAction: PropTypes.func,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({})
  ]),
  title: PropTypes.string
};

WarningModal.defaultProps = {
  buttonAction: '',
  buttonCancel: 'button.cancel',
  buttonConfirm: 'button.confirm',
  onAction: null,
  onCancel: null,
  onConfirm: null,
  text: '',
  title: 'warnings.warning'
};

export default WarningModal;